/**
 * @file constants
 * 共通で用いる用語などの定数
 */

/**
 * 申し込みステータス
 */
export const ContractStatusText = {
  status_1000: '新規',
  status_2000: '申込',
  status_3000: '保留',
  status_4000: '否決',
  status_5000: '架電待ち',
  status_6000: '仮承認',
  status_7000: '承認',
  status_8000: '契約',
  status_9000: 'キャンセル'
}

/**
 * TFICから送られてくる申し込みステータス
 */
export const tficContractStatus = [
  {value: 0, label: '申込'},
  {value: 1, label: '保留'},
  {value: 2, label: '否決'},
  {value: 3, label: 'キャンセル'},
  {value: 4, label: '仮承認'},
  {value: 5, label: '承認'},
  {value: 6, label: '契約'}
]

/**
 * 自社割賦の詳細情報
 */
export const InstallmentText = {}

/**
 * 商品情報
 */
export const ProductInputText = {
  product: '商品',
  product_other_name: '商品のその他候補',
  cash_total: '現金価格合計',
  down_payment: '頭金',
  remaining_money: '残金（申し込み金額）',
  payment: '支払方法 ',
  split_number: '分割回数',
  bonus_combined_addition_amount: 'ボーナス併用加算額',
  bonus_combined_month: 'ボーナス加算月',
  bonus_combined_month1: '夏',
  bonus_combined_month2: '冬',
  bonus_combined_number: 'ボーナス加算回数',
  bonus_combined_payment: 'ボーナス併用金額',
  bonus_once_month: '支払月1回目',
  bonus_twice_month: '支払月2回目',
  payment_period_start: '支払期間 開始',
  payment_period_start_y: '年',
  payment_period_start_m: '月',
  payment_period_end: '支払期間 終了',
  payment_amount_once: '支払金額 第1回目',
  payment_amount_second: '支払金額 第2回目以降',
  split_fee: '分割手数料',
  split_total_payment: '分割支払合計',
  bonus_fee: '手数料',
  total_pay: '支払総額',
  person_charge: '担当者 フルネーム',
  service_start_date: '役務提供期間 開始',
  service_end_date: '役務提供期間 終了'
}

/**
 * 支払い方法
 */
export const PayTypeText = {
  split: '分割払い',
  split_bonus: '分割払い・ボーナス併用',
  once: 'ボーナス一括払い',
  seconds: 'ボーナス２回払い',
  monthly: 'マンスリークリア(1回払)'
}

/**
 * 個人情報入力
 */
export const UserInputText = {
  application_date: '申込日',
  purpose_of_transaction: '取引を行う目的',
  purpose_of_transaction_other_name: '取引を行う目的のその他候補',
  is_foreign_government: '外国政府等重要な公的地位にある方等とのお取引に該当する',
  foreign_government_company: '国・職名',
  name: '氏名 漢字',
  name_kana: '氏名  フリガナ',
  old_surname: '旧姓 漢字',
  old_surname_kana: '旧姓 カナ',
  sex_type: '性別',
  birthday: '生年月日',
  post_number: '郵便番号',
  street_address: '住所',
  street_address1: '都道府県市区町 番地',
  street_address2: '建物名・部屋番号',
  street_address_kana: '住所カナ',
  fixed_phone: '自宅TEL',
  mobile_phone: '携帯TEL',
  has_spouse: '配偶者',
  parent_living: '親同居',
  child_status: '子供',
  child_number: '子供の人数',
  others_status: 'その他',
  others_number: 'その他の人数',
  family_about: 'ご家族について',
  family_about_number: '同居人数',
  family_structure: '世帯人数（同一生計人数）',
  residence_classification: 'ご住居',
  residence_period_year: '居住年数',
  loan_rent: '申込者又はその配偶者の住宅ローン・家賃のお支払い',
  householder_relation: 'お申込者と世帯主の関係',
  householder_income: '世帯主の税込年収 ',
  householder_income_type: '世帯主の所得種類',
  householder_income_type_other_name: '世帯主の所得種類のその他候補',
  householder_monthly_credit_payments: '世帯主のクレジット月間支払額 ',
  parents_post: '実家郵便番号',
  parents_address: '都道府県市区町 番地',
  parents_phone: '実家TEL',
  parents_mobile_phone: '実家携帯TEL',
  parents_phone_relationship: '実家携帯電話の続柄',
  parents_phone_relationship_other_name: '実家携帯電話の続柄 (その他)',
  occupation: 'お勤め先・学校について',
  occupation_other_name: 'お勤め先・学校についてのその他候補',
  graduate: '卒業予定',
  graduate_year: '卒業予定(西暦)',
  graduate_month: '卒業予定(月)',
  company_name: 'お勤め先名称',
  company_name_kana: 'お勤め先名称 フリガナ ',
  company_phone: 'お勤め先TEL ',
  company_job_description: '仕事内容',
  company_job_description_other_name: '仕事内容のその他候補',
  job_department: '所属部課',
  dispatched_agent: '出向派遣元',
  company_post: 'お勤め先郵便番号',
  company_address: 'お勤め先住所',
  join: '入社年月',
  join_year: '入社年',
  join_month: '入社月',
  payday: '給料日',
  company_income: '税込年収',
  sideline_type: 'その他収入(年額) ',
  sideline_other_name: 'その他収入(年額)のその他候補',
  sideline_income: 'その他収入(年額)の金額',
  is_change_customer: '変更届',
  is_change_account: '引落口座名義変更の有無'
}

/**
 * 画像アップロード
 */
export const UploadText = {
  direct_debit: '口座振替確認',
  identification: '本人確認書類',
  contract_documents: 'エステ契約書、美容医療契約書、売買契約書、口座振替依頼書等',
  parental_consent: '親権同意書',
  bank_account_holder: '口座名義人',
  bank_account_holder_name: '口座名義人名',
  bank_account_registration: '口座登録',
  bank_account_registration_date: 'A済 日付',
  is_beri: '本人確認電話',
  beri_timing: '確認日時',
  beri_at: '指定日時'
}

/**
 * バリデーションのmessageのときの定義
 */
export const ValidationText = {
  ...ProductInputText,
  ...PayTypeText,
  ...UserInputText,
  ...UploadText
}

/**
 * 申込分類
 */
export const ApplicationCategory = {
  credit: '自社割賦',
  installment: '信販'
}

/**
 * 申込可能な年齢の制限
 */
export const AgeLimit = {
  credit: {
    low: 18,
    high: 69
  },
  installment: {
    low: 0,
    high: 69
  }
}
